import { Stack } from "@mui/material";
import { ScheduleCommonActions } from "../scheduleCommon/ScheduleCommonActions";

interface ScheduleDerivsActionsLeftProps {
  eventId?: number;
}

export const ScheduleDerivsActionsLeft = ({
  eventId
}: ScheduleDerivsActionsLeftProps) => {
  return (
    <Stack direction="row" spacing='10px' sx={{ height: '26px', marginTop: '-4px', alignItems: 'center' }}>
      {eventId &&
        <ScheduleCommonActions eventId={eventId} />
      }
    </Stack>
  )
}
